export default function checkSubmitData(submitData, ignoreList) {
  if (ignoreList === void 0) {
    ignoreList = [];
  }
  const setInputError = window.katerCore.setInputError;
  let isValid = true;
  for (let index in submitData) {
    if (submitData[index] === null) {
      continue;
    }
    if (ignoreList.indexOf(index) === -1 && submitData[index].length === 0 && $("#" + index).length > 0 && $("#" + index).prop('disabled') !== true) {
      setInputError("#" + index, isValid);
      isValid = false;
    }
  }
  return isValid;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/checkSubmitData', checkSubmitData);